import React from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import BackAnchor from 'shared/components/BackAnchor'
import { changeObjectPropertyAction } from 'redux/actions'

const UpdateMailingAddressQuestionView = ({ t, i18n }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const handleClick = (isMailingAddress) => () => {
    dispatch(changeObjectPropertyAction('mailingAddress', 'isMailingAddress', isMailingAddress))
    if (isMailingAddress) {
      history.push(`/${i18n.language}${t('routes.mailing_address')}`)
    } else {
      history.push(`/${i18n.language}${t('routes.review_summary')}`)
    }
  }

  return (
    <div className="container">
      <main>
        <article className="col-md-8">
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('update_mailing_address_question.do_you_want_to_update_mailing_address')}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <button
                className="ns-btn-yes-no btn-default"
                style={{ marginRight: '20px' }}
                value={t('screening_question.yes')}
                name={t('screening_question.yes')}
                onClick={handleClick(true)}
              >
                {' '}
                {t('screening_question.yes')}
              </button>
              <button
                className="ns-btn-yes-no btn-default"
                style={{ marginRight: '20px' }}
                value={t('screening_question.no')}
                name={t('screening_question.no')}
                onClick={handleClick(false)}
              >
                {' '}
                {t('screening_question.no')}
              </button>
            </div>
          </div>
        </article>
      </main>
    </div>
  )
}

export default withTranslation('common')(UpdateMailingAddressQuestionView)
